import { Button, Col, Flex, message, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import PolicyComponent from "../../components/Policy";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import API from "../../services/api-request";

const Policy = () => {
  const navigate = useNavigate();
  const [fishData, setFishData] = useState([]);

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      width: 60,
      render: (a, b, index) => index + 1,
    },
    {
      title: "Tipe Produk",
      dataIndex: "type",
      key: "type",
      width: 150,
      sorter: (a, b) => {
        if (a.type === null || a.type === "-") return 1;
        if (b.type === null || b.type === "-") return -1;
        return a.type.localeCompare(b.type);
      },
      render: (type) => {
        if (type === null || type === "-") {
          return "-";
        } else {
          return type;
        }
      },
    },
    {
      title: "Jenis Produk",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => {
        if (a.name === null || a.name === "-") return 1;
        if (b.name === null || b.name === "-") return -1;
        return a.name.localeCompare(b.name);
      },
      render: (name) => {
        if (name === null || name === "-") {
          return "-";
        } else {
          return name;
        }
      },
    },
    {
      title: "Tarif 7 Hari Pertama",
      dataIndex: "firstWeek",
      key: "firstWeek",
      sorter: (a, b) => {
        if (a.firstWeek === null || a.firstWeek === "-") return 1;
        if (b.firstWeek === null || b.firstWeek === "-") return -1;
        return a.firstWeek - b.firstWeek;
      },
      render: (firstWeek) => {
        if (firstWeek === null || firstWeek === "-") {
          return "-";
        } else {
          return "Rp " + firstWeek.toLocaleString("id-ID");
        }
      },
    },
    {
      title: "Tarif Selanjutnya",
      dataIndex: "perDay",
      key: "perDay",
      sorter: (a, b) => {
        if (a.perDay === null || a.perDay === "-") return 1;
        if (b.perDay === null || b.perDay === "-") return -1;
        return a.perDay - b.perDay;
      },
      render: (perDay) => {
        if (perDay === null || perDay === "-") {
          return "-";
        } else {
          return "Rp " + perDay.toLocaleString("id-ID");
        }
      },
    },
  ];

  const getFishData = async () => {
    let tempFishData = [];

    await API.Get("public/product")
      .then((res) => {
        const data = res?.data;

        data.map((fishData) => {
          tempFishData.push({
            id: fishData.id,
            name: fishData.name,
            type: fishData.product_type.size,
          });
        });

        getCostData(tempFishData);
      })
      .catch((err) => {
        console.log(err);

        message.error("Failed to fetch fish data.");
      });
  };

  const getCostData = async (tempFishData) => {
    await API.Get("storage-cost/public")
      .then((res) => {
        const data = res?.data;

        if (!tempFishData || !Array.isArray(data)) return;

        const costMap = new Map();
        data.forEach((item) => {
          costMap.set(item.product_type.size, {
            firstWeek: item.first_week_fee,
            perDay: item.daily_fee,
          });
        });

        const updatedFishData = tempFishData.map((fish) => {
          const cost = costMap.get(fish.type);
          return cost
            ? { ...fish, firstWeek: cost.firstWeek, perDay: cost.perDay }
            : fish;
        });

        setFishData(updatedFishData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getFishData();
  }, []);

  return (
    <Flex
      justify="center"
      align="center"
      style={{
        backgroundColor: "#e4eafb",
        minHeight: "100vh",
        maxHeight: "100%",
        paddingTop: "2rem",
        paddingBottom: "2rem",
      }}
    >
      <Row
        gutter={24}
        style={{
          backgroundColor: "white",
          borderRadius: "20px",
          padding: "1rem",
          maxWidth: "60svw",
        }}
      >
        <Col span={24}>
          <Button
            onClick={() => navigate(-1)}
            color="default"
            variant="link"
            style={{
              fontSize: "clamp(12px, 1.5vw, 16px)",
              //   marginBottom: "20px",
            }}
            icon={<ArrowLeftOutlined />}
          >
            Kembali
          </Button>
        </Col>
        <Col span={24} style={{ marginBottom: "2rem" }}>
          <PolicyComponent isPublic={true} />
        </Col>

        <Col span={24} style={{ padding: "0 16px" }}>
          <h2>Daftar Harga</h2>
          <hr />
        </Col>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={fishData}
            pagination={{
              pageSize: 5,
              showSizeChanger: false,
            }}
            rowKey={(dataSource) => dataSource.id}
          />
        </Col>
      </Row>
    </Flex>
  );
};

export default Policy;
